<section>
    
    <header>
      @if(currentViewState() === viewStates.Detail){
      <nav>
        <img src="/assets/img/mobile/blue-arrow-left.svg" alt="arrow left" />
        <span class="linkspan"  (click)="goBackToList()">Go to Similar proteins </span>
      </nav>
      }
      <section class="header">
        <h2>
          {{title()}}
        </h2>
        <div class="controls">
          <img src="/assets/img/mobile/mb-arrow-{{expanded() ? 'down':'up'}}.svg" alt="arrow up" (click)="toggleBottomsheetHeight()" />
        </div>
      </section>
    </header>
    <div style="padding: 12px;">

      @if(currentViewState() === viewStates.List){ @for(menu of listHomeMenu; track menu; let i = $index;){
        <div class="mb-domains-container" (click)="navigateToDetail(menu)">
          <div class="domain-parent">
            <div class="mb-domain-info">
              <div class="mb-domain-title">{{menu.title}}</div>
              <img class="arrow-right-icon" alt="" src="/assets/img/mobile/arrow-right.svg">
            </div>
            <div class="mb-cath-link">
              <div class="mb-cath-link1">{{menu.subtitle}}</div>
            </div>
          </div>
        </div>
      }}
      
      @if(currentViewState() === viewStates.Detail && activeMenu().id === 1){
        <div class="sectionContent"></div>
        <app-cluster-table
        [accession]="accession()"
        [uniprotAccession]="uniprotAccession()"
        ></app-cluster-table>
      }
     
      @if(currentViewState() === viewStates.Detail && activeMenu().id === 2){
        <mb-foldseek-table
        [afdb_accession]="afdb_accession"
        [accession]="accession()"
        (handleSelectedStructure) = "handleSelectedStructure($event)"
        ></mb-foldseek-table>
      }
     
    </div>
</section>    


